// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"ManuaisGer_containerPrincipal__4D89b","divManuais":"ManuaisGer_divManuais__PxzXx","divTitulo":"ManuaisGer_divTitulo__PR7JH"};